import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary, RaikoConfirmDialog, RaikoCreatorInfo,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    showWarningMessage,
    RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage, showSuccessMessage, dataURLtoFile
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import UploadThumbnail from "../../component/uploadThumbnail/UploadThumbnail";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {NewsService} from "../../serverService/news/NewsService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import RaikoCustomEditor2 from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import {stringIsEmpty} from "../../util/VariableChecker";
import InternalImageSelector from "../../raikoComponents/raikoEditor/internalImageSelector/InternalImageSelector";
import {FileManagerTypes} from "../../component/fileManager/FileManager";

export default function NewsDetail() {

    const {id: newsId} = useParams()
    const {state} = useLocation()

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new NewsService()

    const [title, setTitle] = useState("");
    const [newsWriter, setNewsWriter] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState([])
    const [photoUrl, setPhotoUrl] = useState("");
    const [photoId, setPhotoId] = useState(-1);

    const [createBy, setCreateBy] = useState("")
    const [createAt, setCreateAt] = useState("")


    useEffect(() => {
        getNewsDetailFromServer()
    }, [])

    function getNewsDetailFromServer() {
        loading.show()
        service.getNewsDetail(newsId).then(
            response => {
                setTitle(response.title)
                setNewsWriter(response.authorInformation)
                setShortDescription(response.shortDescription)
                setDescription(response.contents)
                setCreateBy(response.postedBy)
                setCreateAt(convertUniversalDateTimeToPersianDateTime(response.postedAt))
                if (response.thumbnail) {
                    setPhotoId(response.thumbnail.id)
                    setPhotoUrl(response.thumbnail.url)
                }
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }


    const [newsTitle, setNewsTitle] = useState(state && state.title ? state.title : RouteHelper.MagazineNewsDetail.name)

    const navigate = useNavigate()

    function checkAllFields() {
        let state = false
        let message
        if (stringIsEmpty(title))
            message = "لطفا عنوان خبر را به درستی وارد نمایید."
        else if (stringIsEmpty(newsWriter))
            message = "لطفا نویسنده خبر را به درستی وارد نمایید."
        else if (photoId === -1)
            message = "لطفا تصویر شاخص را انتخاب نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه خبر را به درستی وارد نمایید."
        else if (stringIsEmpty(description))
            message = "لطفا توضیحات خبر را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state
    }

    function updateNews() {
        if (checkAllFields()) {
            loading.show()
            service.updateNews(newsId, photoId, title, newsWriter, description, shortDescription, true).then(
                showSuccessMessage("بروزرسانی با موفقیت انجام شد")
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    //dialog
    const [openDeleteDialogState, setOpenDeleteDialogState] = useState(false);

    function closeDeleteDialog() {
        setOpenDeleteDialogState(false)
    }

    function openDeleteDialog() {
        setOpenDeleteDialogState(true)
    }

    function handleDeleteNews() {
        loading.show()
        service.deleteNews(newsId).then(
            response => {
                showSuccessMessage("خبر با موفقیت حذف شد.")
                closeDeleteDialog()
                navigate(RouteHelper.MagazineNews.globalUrl,

                    {replace: true})
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    //dialog
    return (
        <>
            <Helmet>
                <title>{RouteHelper.MagazineNewsDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openDeleteDialogState}
                doAction={handleDeleteNews}
                pageTitle={"حذف خبر"}
                warningTitle={"آیا از حذف خبر اطمینان دارید؟"}
            />
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.MagazineNews.name,
                                    RouteHelper.MagazineNews.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    newsTitle,
                                    ""
                                )
                            ]}
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}
                        />
                    </RaikoFlexFirstChildGrowOne>
                    <RaikoBaseCardContainer>
                        <RaikoSectionContainer
                            title={"اطلاعات پایه"}
                            hasActionButton={true}
                            actionButtonTitle={"بروزرسانی"}
                            actionButtonOnclick={updateNews}
                            hasSecondaryButton={true}
                            secondaryButtonTitle={"حذف خبر"}
                            secondaryButtonOnClick={openDeleteDialog}
                        >
                            <RaikoGridOneColumn>
                                <InternalImageSelector
                                    value={photoUrl}
                                    setValue={setPhotoUrl}
                                    imageId={photoId}
                                    setImageId={setPhotoId}
                                    bucketId={FileManagerTypes.NEWS_THUMBNAILS.id}
                                    title={"تصویر شاخص"}
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"عنوان"}
                                    value={title}
                                    setValue={setTitle}
                                />
                                <RaikoMaterialOutlinedInput
                                    labelText={"نویسنده"}
                                    value={newsWriter}
                                    setValue={setNewsWriter}
                                />
                                <RaikoSimpleMultiLineInputOutlined
                                    labelText={"توضیحات کوتاه"}
                                    value={shortDescription}
                                    setValue={setShortDescription}
                                />
                                <RaikoSectionContainer title={"توضیحات"}>
                                    <RaikoCustomEditor2
                                        value={description}
                                        setValue={setDescription}
                                    />
                                </RaikoSectionContainer>
                            </RaikoGridOneColumn>

                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                    <RaikoCreatorInfo createdBy={createBy} createdAt={createAt}/>

                </RaikoGridOneColumn>

            </RaikoBaseContainer>
        </>
    )
}